import {
  Breadcrumbs,
  BreadcrumbRouteMapFn as BreadcrumbRouteMapFn_,
  BreadcrumbRouteMap as BreadcrumbRouteMap_,
} from './Breadcrumbs';

export type BreadcrumbRouteMapFn = BreadcrumbRouteMapFn_;
export type BreadcrumbRouteMap = BreadcrumbRouteMap_;
export default Breadcrumbs;
